import React, { ReactElement } from 'react';
import { Document2Icon, CheckGreenCircle } from 'assets/icons';

interface StatusConfigItem {
  text?: string;
  background: string;
  textColor: string;
  // El ícono puede ser un React Element (SVG/Componente) o un string (URL de imagen)
  icon: ReactElement | string | any;
  tooltipText?: string;
}

/**
 * Configuración de estados para los certificados Apacuana.
 * Contiene estilos de Tailwind (colores) e iconos SVG/React.
 */
export const STATUS_CONFIG: Record<string, StatusConfigItem> = {
  'No Certificado': {
    background: '#85858533',
    textColor: '#515151B2',
    icon: Document2Icon, // Asumido como una referencia externa (string o componente)
  },
  Verificado: {
    text: 'Verificado',
    background: '#D4F3EA',
    textColor: '#009F6F',
    tooltipText: undefined,
    icon: CheckGreenCircle,
  },

  'Por verificar': {
    text: 'Por verificar',
    background: '#FEF3C7',
    textColor: '#BA8F1E',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    ),
    tooltipText:
      'La información y documentos enviados están siendo revisados por la Autoridad de Registro.',
  },
  'En revisión': {
    text: 'Por verificar',
    background: '#FEF3C7',
    textColor: '#BA8F1E',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    ),
    tooltipText:
      'La información y documentos enviados están siendo revisados por la Autoridad de Registro.',
  },
  'Por generar': {
    text: 'Por generar',
    background: '#FEF3C7',
    textColor: '#BA8F1E',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    ),
    tooltipText:
      'Tu solicitud fue aprobada. Solo falta que generes tu certificado para comenzar a usarlo.',
  },
  'En progreso': {
    text: 'En progreso',
    background: '#FEF3C7',
    textColor: '#BA8F1E',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    ),
  },
  'Certificado expirado': 'Certificado expirado' as any, // Mantenemos la definición original simple si no se usa el objeto completo
  'Por revocar': {
    text: 'Por revocar',
    background: '#FEE2E2',
    textColor: '#F87171',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    ),
    tooltipText:
      'Recibimos tu solicitud de revocación y estamos procesándola. El certificado dejará de ser válido una vez finalice el trámite.',
  },
  Revocado: {
    text: 'Revocado',
    background: '#85858533',
    textColor: '#515151B2',
    tooltipText:
      'Este certificado ha sido revocado. Debes solicitar uno nuevo.',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    ),
  },
  'Certificado generado en otro dispositivo': {
    text: 'Certificado generado en otro dispositivo',
    background: '#85858533',
    textColor: '#515151B2',
    tooltipText:
      'Este certificado ha sido revocado. Debes solicitar uno nuevo.',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
    ),
  },
};
